import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Bead from "../common/Bead";
import { connect } from "react-redux";
import * as types from "../../constants/ComponentConstants";
import * as domainConstants from "../../constants/DomainConstants";

const Beads = (props) => {

    const { items, typeAanvraagId, isVoortgangsrapportScope, hideVerantwoordingsTab } = props;
    const beadstatesEnum = {
        0: "empty",
        1: "half",
        2: "full"
    };

    let isTopsportDossier;

    if (typeAanvraagId)
        isTopsportDossier = typeAanvraagId == domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW || typeAanvraagId == domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE;

    const tabOrder = getTabOrder(isVoortgangsrapportScope, hideVerantwoordingsTab, isTopsportDossier);

    let sortedItems = [];
    let percentage = 0;

    if (items)
        tabOrder.forEach((value, index) => {
            let filteredItems = items.filter(x => x.tab === value);
            if (filteredItems.length && value === 13)
                filteredItems[0].status = items.filter(x => [14, 15, 16, 17].indexOf(x.tab) > -1 && x.status === 2).length === 4 ? 2 : filteredItems[0].status;
            sortedItems = sortedItems.concat(filteredItems);
            percentage = getPercentage(items);
        });

    return (items && items.length > 0 ?
        (<div className="c-beads-wrapper">
            <div className="c-beads">
                {items ? sortedItems.map((bead, i) => {
                    let beadProps = {
                        beadstate: getBeadStatus(bead.status),
                        small: getBeadSize(bead.tab),
                        tooltipText: getBeadTooltipText(bead.titel, bead.status),
                        color: getBeadColor(bead.tab)
                    };
                    return (<Bead key={i} {...beadProps} />);
                }) : ""}
                <span>Jouw {isVoortgangsrapportScope ? "rapport" : "dossier"} is {percentage}% volledig</span>
            </div>
        </div>) : null
    );
};

function getTabOrder(isVoortgangsrapportScope, hideVerantwoordingsTab, isTopsportDossier) {
    if (isVoortgangsrapportScope)
        return hideVerantwoordingsTab ? [10, 11] : [10, 11, 12];

    return isTopsportDossier ? [0, 1, 2, 6, 13, 14, 15, 16, 17, 3, 7, 5] : [0, 1, 2, 6, 13, 14, 15, 16, 17, 3, 7, 4, 5];
}

function getBeadTooltipText(title, status) {
    if (title === "Bovenlokaliteit (Algemeen)") {
        if (status === 0) {
            return "Geen infrastructuren gedefinieerd in project";
        }
        return "Bovenlokaliteit";
    }

    if (title === "Financieel (Algemeen)") {
        return "Financieel";
    }

    let tooltipText = title;
    let tooltipTexts = {
        0: "Tab '" + title + "' is leeg.",
        1: "Tab '" + title + "' is nog niet volledig.",
        2: "Tab '" + title + "' is volledig."
    };
    tooltipText = tooltipTexts[status];
    return tooltipText;
}

function getBeadColor(tab) {
    let defaultColor = "gray";
    let color = defaultColor;
    let colors = {
        0: types.COLOR_BLUE,
        1: types.COLOR_PINK,
        2: types.COLOR_GREEN_LIGHT,
        3: types.COLOR_PURPLE,
        4: types.COLOR_ORANGE,
        5: types.COLOR_ORANGE,
        6: types.COLOR_GREEN_LIGHT,
        7: types.COLOR_PURPLE,
        10: types.COLOR_PINK,
        11: types.COLOR_ORANGE,
        12: types.COLOR_PINK_LIGHT,
        13: types.COLOR_PINK_LIGHT,
        14: types.COLOR_PINK_LIGHT,
        15: types.COLOR_PINK_LIGHT,
        16: types.COLOR_PINK_LIGHT,
        17: types.COLOR_PINK_LIGHT
    };
    color = colors[tab];
    return color;
}

function getBeadSize(tab) {
    let smallSize = false;
    if (tab === 6
        || tab === 7
        || tab === 14
        || tab === 15
        || tab === 16
        || tab === 17) {
        smallSize = true;
    }
    return smallSize;
}

function getBeadStatus(status) {
    let state = "empty";
    let statusEnum = {
        0: "empty",
        1: "half",
        2: "full"
    };
    state = statusEnum[status];
    return state;
}

function getPercentage(items) {
    let perc = 0;
    let totalItemsCount = items.length;
    let completedItemsCount = items.filter((x => x.status === 2)).length;
    perc = parseInt((completedItemsCount / totalItemsCount) * 100);
    return perc;
}

Beads.propTypes = {
    typeAanvraagId: PropTypes.string,
    items: PropTypes.array,
    isVoortgangsrapportScope: PropTypes.bool,
    hideVerantwoordingsTab: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return {
        items: state.layout.showVoortgangsrapportLayout ? state.voortgangsrapportBeads : state.beads,
        isVoortgangsrapportScope: state.layout.showVoortgangsrapportLayout,
        hideVerantwoordingsTab: state.layout.showVoortgangsrapportLayout ? !state.layout.voortgangsrapportTopNavTabSettings.verantwoordingTab.visible : null
    };
}

export default connect(mapStateToProps)(Beads);